// =============================================================
// Formatters for prices, market cap, percentages
// =============================================================

/**
 * Format price with appropriate decimal places.
 * $96,432.00 for large, $0.0000221 for micro-caps
 */
export function formatPrice(price: number): string {
  if (price == null) return '$—'
  if (price >= 1000)
    return `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  if (price >= 1) return `$${price.toFixed(2)}`
  if (price >= 0.01) return `$${price.toFixed(4)}`
  if (price >= 0.0001) return `$${price.toFixed(6)}`
  return `$${price.toFixed(8)}`
}
/**
 * Format large numbers into compact form.
 * $1.89T, $42.3B, $12.3M
 */
export function formatCompact(num: number): string {
  if (num >= 1e12) return `$${(num / 1e12).toFixed(2)}T`
  if (num >= 1e9) return `$${(num / 1e9).toFixed(1)}B`
  if (num >= 1e6) return `$${(num / 1e6).toFixed(1)}M`
  return `$${num.toLocaleString('en-US')}`
}

/**
 * Format percentage change with sign.
 * +2.31% or -1.12%
 */
export function formatChange(change: number): string {
  if (change == null || isNaN(change)) return '0.00%'
  const sign = change >= 0 ? '+' : ''
  return `${sign}${change.toFixed(2)}%`
}

/**
 * Format supply numbers with coin symbol.
 * 19.8M BTC, 120.0M ETH
 */
export function formatSupply(supply: number, symbol: string): string {
  if (supply >= 1e12) return `${(supply / 1e12).toFixed(1)}T ${symbol}`
  if (supply >= 1e9) return `${(supply / 1e9).toFixed(1)}B ${symbol}`
  if (supply >= 1e6) return `${(supply / 1e6).toFixed(1)}M ${symbol}`
  return `${supply.toLocaleString('en-US')} ${symbol}`
}

